import { gsapSingleton, scrollTriggerSingleton, drawSVGPluginSingleton } from "../gsap";
import $ from 'jquery';
import Component from '../models/Component';

const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();
const DrawSVGPlugin = drawSVGPluginSingleton();

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

export default class DecorationsAnimation extends Component {
  constructor(element, context) {
    super(element, context);

    // Rimuovi la classe di opacità iniziale quando l'animazione inizia
    this.element.find('svg').css('opacity', 1);

    const Outline = this.element.find('svg .outline-path');
    const Solid = this.element.find('svg .solid-path');

    if (Outline.length) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.element,
          start: "top 60%",
          markers: false,
        },
      });

      tl.fromTo(Outline, 
          {
            drawSVG: "0%",
          },
          {
            drawSVG: "100%",
            duration: 3, 
            ease: 'power3.inOut',
        }, 
      ); 
    }

    if (Solid.length) {
      const solidTl = gsap.timeline({
        scrollTrigger: {
          trigger: this.element,
          start: "top center",
          markers: false,
        },
      });
      solidTl.fromTo(
        Solid,
        {
          drawSVG: "0%",
        },
        {
          drawSVG: "100%",
          duration: 1,
          ease: "linear",
        }
      ).fromTo(
        Solid,
        {
          fillOpacity: 0,
        },
        {
          fillOpacity: 1,
          duration: 0.5,
          ease: "linear",
        },
        "+=0.5"
      );
    }
  }
}
